import { render } from "./numberControl.vue?vue&type=template&id=b33cf29a&scoped=true"
import script from "./numberControl.vue?vue&type=script&lang=js"
export * from "./numberControl.vue?vue&type=script&lang=js"

import "./numberControl.vue?vue&type=style&index=0&id=b33cf29a&scoped=true&lang=css"
import "./numberControl.vue?vue&type=style&index=1&id=b33cf29a&lang=css"
script.render = render
script.__scopeId = "data-v-b33cf29a"

export default script